export default __webpack_public_path__ + "static/media/Tracy_Headshot_v3.6ad2cbe3.jpg";